// Bounds for source verification only; these never control real Player playback.
const HTTP_CHECK_TIMEOUT_MS = 16000;
const PLAYBACK_CHECK_TIMEOUT_MS = 15000;
const VERIFICATION_WINDOW_MS = 120000;

const streamVerificationGroup = (mediaType, streamId, videoId) => {
    const id = typeof videoId === 'string' && videoId ? videoId : streamId;
    return typeof mediaType === 'string' && mediaType && typeof id === 'string' && id
        ? JSON.stringify([mediaType, id]) : null;
};

module.exports = { HTTP_CHECK_TIMEOUT_MS, PLAYBACK_CHECK_TIMEOUT_MS, VERIFICATION_WINDOW_MS, streamVerificationGroup };
